module.exports = __webpack_public_path__ + "img/q1_2021.b158190c.png";